import Text, { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import { COLOR_VALUES } from "shared/config/colors";
import styled, { css } from "styled-components/macro";

export const InputLabel = styled.label`
    word-break: break-all;
    color: ${COLOR_VALUES.Gray_1};
    ${(props) =>
        props.labelVariant
            ? css`
                  ${props.labelVariant}
              `
            : css`
                  ${TEXT_VARIANT_STYLES.Headline_5}
              `};

    margin: 0;
`;

export const FormInputWrapperText = styled(Text)`
    word-break: break-all;
`;

export const Wrapper = styled.fieldset`
    margin: 0;
    padding: 0;
    border: 0;

    &:not(:first-child) {
    }

    &:not(:last-child) {
    }
`;
